export default {
	//count: state => state.count, //取得state裡面的內容
	//datalist : state => state.datalist,
	user : state => state.user,
	config : state => state.config,
	web : state => state.web,
}


// WEBPACK FOOTER //
// ./src/store/getters.js